/**
 * Dev-only editor gating (ADR-0002): creator tooling never reaches end users. This is a
 * BUILD-ENV flag, not runtime auth — worlds are public data, the editor is not a secret, it is
 * simply not shipped UX. PURE (no DOM, no import.meta) so the logic is unit-testable; mount
 * passes `import.meta.env` in. When this returns false, mount wires neither the F2 handler nor
 * the panel button nor any reachable path to the editor's lazy import.
 */
export function editorEnabled(env: { DEV: boolean; VITE_ENABLE_EDITOR?: string }): boolean {
  return env.DEV || env.VITE_ENABLE_EDITOR === '1';
}
